// Keys can appear in metrics; keep credentials only in this in-memory lookup.
const credentialScopes = new Map();
let nextScope = 0;
export const credentialCacheScope = token => {
  if (!token) return `implicit-${++nextScope}`;
  if (!credentialScopes.has(token)) credentialScopes.set(token, `credential-${++nextScope}`);
  return credentialScopes.get(token);
};
